/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const check = () => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.724 9.349l.907.733.77-.875 5.82-6.597L10.394 1l-5.13 5.815-2.735-2.37L1 6.34z" />
  </svg>
);
